import { Expose } from "class-transformer";
import { ProductCategories } from "src/constants/product-categories";
import { BaseModel } from "src/shared/models/base.model";
import { BenefitsStorage } from "src/containers/wellbeing/shared/constants/storage";

class BenefitDiscount extends BaseModel {
    @Expose() id = 0;

    @Expose() image = "";

    @Expose() title = "";

    @Expose() subtitle = "";

    @Expose() rate? = 0.0;

    @Expose() label? = "";

    @Expose() discountCode? = "";

    @Expose() category = ProductCategories.UNKNOWN;

    @Expose() order = 0;

    get imageUrl() {
        if (this.image.startsWith("/static")) {
            return this.image;
        }
        return `${BenefitsStorage.Discounts}/${this.image}.webp`;
    }

    get fallbackImageUrl() {
        if (this.image.startsWith("/static")) {
            return this.image.replace(".webp", ".jpg");
        }
        return `${BenefitsStorage.Discounts}/${this.image}.jpg`;
    }
}

export { BenefitDiscount };
